

export interface RichCommandGroup {
    groupName: string;
    values: Array<string | RichEditorCommand>;
    selected?: boolean;
}

export type SelectedCommand = Array<string | RichCommandGroup>;

/** ç¼è¾å¨èªå®ä¹å·¥å·æ ç±»å */
export type RichTextEditorToolbars = SelectedCommand;


export interface RichEditorCommand {
    code: string;
    cls: string;
    title: string;
    value: any;
    selected?: boolean;
    visible?: boolean;
}
// ['bold', 'italic', 'code-block', { header: 1 }, { header: 2 }, { list: 'ordered' }, { list: 'bullet' }, 'image']
export const RICH_COMMANDS = {
    concise: [
        // { visible: true, code: 'formatselect', cls: 'mr-1 f-icon f-icon-convert-lowercase', title: 'æ®µè½&æ é¢', value: [{ header: [1, 2, 3, 4, 5, 6, false] }] },
        // { visible: true, code: 'fontselect', cls: 'mr-1 f-icon f-icon-font-family', title: 'å­ä½', value: [{ font: ['Microsoft-YaHei', 'SimSun', 'SimHei', 'KaiTi', 'FangSong', 'Arial', 'Times', 'sans-serif'] }] },
        // { visible: true, code: 'fontsizeselect', cls: 'mr-1 f-icon f-icon-font-size', title: 'å­å·', value: [{ size: ['small', false, 'large', 'huge'] }] },
        { visible: true, code: 'bold', cls: 'mr-1 rich-toolbar-icons rich-bold', title: 'å ç²', value: ['bold'] },
        { visible: true, code: 'italic', cls: 'mr-1 rich-toolbar-icons rich-italic', title: 'å¾æ', value: ['italic'] },
        { visible: true, code: 'underline', cls: 'mr-1 rich-toolbar-icons rich-underline', title: 'ä¸åçº¿', value: ['underline'] },
        { visible: true, code: 'strike', cls: 'mr-1 rich-toolbar-icons rich-strike', title: 'å é¤çº¿', value: ['strike'] },
        { visible: true, code: 'numlist', cls: 'mr-1 rich-toolbar-icons rich-ordered', title: 'æåºåè¡¨', value: [{ list: 'ordered' }] },
        { visible: true, code: 'bullist', cls: 'mr-1 rich-toolbar-icons rich-bullet', title: 'æ åºåè¡¨', value: [{ list: 'bullet' }] },
        // { visible: true, code: 'outdent', cls: 'mr-1 rich-toolbar-icons rich-indent-1', title: 'åæ¶ç¼©è¿', value: [{ indent: '-1' }] },
        // { visible: true, code: 'indent', cls: 'mr-1 rich-toolbar-icons rich-indent1', title: 'ç¼©è¿', value: [{ indent: '+1' }] },
        // { visible: true, code: 'forecolor', cls: 'mr-1 rich-toolbar-icons rich-color', title: 'ææ¬é¢è²', value: [{ color: [] }] },
        // { visible: true, code: 'backcolor', cls: 'mr-1 rich-toolbar-icons rich-background', title: 'èæ¯è²', value: [{ background: [] }] },
        // { visible: true, code: 'link', cls: 'mr-1 rich-toolbar-icons rich-link', title: 'æå¥é¾æ¥', value: ['link'] },
        // { visible: true, code: 'removeformat', cls: 'mr-1 rich-toolbar-icons rich-clear', title: 'æ¸é¤æ ¼å¼', value: ['clean'] },
        // { visible: true, code: 'blockquote', cls: 'mr-1 rich-toolbar-icons rich-blockquote', title: 'å¼ç¨', value: ['blockquote'] },
        { visible: true, code: 'code-block', cls: 'mr-1 rich-toolbar-icons rich-code-block', title: 'ä»£ç å', value: ['code-block'] },
        { visible: true, code: 'header1', cls: 'mr-1 rich-toolbar-icons rich-header1', title: 'æ é¢ 1', value: [{ header: 1 }] },
        { visible: true, code: 'header2', cls: 'mr-1 rich-toolbar-icons rich-header2', title: 'æ é¢ 2', value: [{ header: 2 }] },
        { visible: true, code: 'image', cls: 'mr-1 rich-toolbar-icons rich-image', title: 'æå¥å¾ç', value: ['image'] },
        // { visible: true, code: 'sub', cls: 'mr-1 rich-toolbar-icons rich-sub', title: 'ä¸æ ', value: [{ script: 'sub' }] },
        // { visible: true, code: 'super', cls: 'mr-1 rich-toolbar-icons rich-super', title: 'ä¸æ ', value: [{ script: 'super' }] },
        // { visible: true, code: 'video', cls: 'mr-1 rich-toolbar-icons rich-video', title: 'æå¥è§é¢', value: ['video'] },
        // { visible: true, code: 'align', cls: 'mr-1 rich-toolbar-icons rich-align', title: 'å¯¹é½æ¹å¼', value: [{align: []}] }
    ],
    advanced: [
        {
            visible: true, code: 'undo',
            cls: 'mr-1 f-icon f-icon-undo',
            title: 'æ¤æ¶',
            value: 'undo'
        },
        {
            visible: true, code: 'redo',
            cls: 'mr-1 f-icon f-icon-redo',
            title: 'éå¤',
            value: 'redo'
        },
        {
            visible: true, code: 'formatselect',
            cls: 'mr-1 f-icon f-icon-convert-lowercase',
            title: 'æ®µè½&æ é¢',
            value: 'formatselect'
        },
        {
            visible: true, code: 'fontselect',
            cls: 'mr-1 f-icon f-icon-font-family',
            title: 'å­ä½',
            value: 'fontselect'
        },
        {
            visible: true, code: 'fontsizeselect',
            cls: 'mr-1 f-icon f-icon-font-size',
            title: 'å­å·',
            value: 'fontsizeselect'
        },
        {
            visible: true, code: 'bold',
            cls: 'mr-1 rich-toolbar-icons rich-bold',
            title: 'å ç²',
            value: 'bold'
        },
        {
            visible: true, code: 'italic',
            cls: 'mr-1 rich-toolbar-icons rich-italic',
            title: 'å¾æ',
            value: 'italic'
        },
        {
            visible: true, code: 'underline',
            cls: 'mr-1 rich-toolbar-icons rich-underline',
            title: 'ä¸åçº¿',
            value: 'underline'
        },
        {
            visible: true, code: 'strike',
            cls: 'mr-1 rich-toolbar-icons rich-strike',
            title: 'å é¤çº¿',
            value: 'strikethrough'
        },
        {
            visible: true, code: 'numlist',
            cls: 'mr-1 rich-toolbar-icons rich-ordered',
            title: 'æåºåè¡¨',
            value: 'numlist'
        },
        {
            visible: true, code: 'bullist',
            cls: 'mr-1 rich-toolbar-icons rich-bullet',
            title: 'æ åºåè¡¨',
            value: 'bullist'
        },
        {
            visible: true, code: 'outdent',
            cls: 'mr-1 rich-toolbar-icons rich-indent-1',
            title: 'åæ¶ç¼©è¿',
            value: 'outdent'
        },
        {
            visible: true, code: 'indent',
            cls: 'mr-1 rich-toolbar-icons rich-indent1',
            title: 'ç¼©è¿',
            value: 'indent'
        },
        {
            visible: true, code: 'forecolor',
            cls: 'mr-1 rich-toolbar-icons rich-color',
            title: 'ææ¬é¢è²',
            value: 'forecolor'
        },
        {
            visible: true, code: 'backcolor',
            cls: 'mr-1 rich-toolbar-icons rich-background',
            title: 'èæ¯è²',
            value: 'backcolor'
        },
        {
            visible: true, code: 'image',
            cls: 'mr-1 rich-toolbar-icons rich-image',
            title: 'æå¥å¾ç',
            value: 'image'
        },
        {
            visible: true, code: 'link',
            cls: 'mr-1 rich-toolbar-icons rich-link',
            title: 'æå¥é¾æ¥',
            value: 'link'
        },
        {
            visible: true, code: 'removeformat',
            cls: 'mr-1 rich-toolbar-icons rich-clear',
            title: 'æ¸é¤æ ¼å¼',
            value: 'removeformat'
        },
        {
            visible: true, code: 'alignleft',
            cls: 'mr-1 f-icon f-icon-align-left',
            title: 'å·¦å¯¹é½',
            value: 'alignleft'
        },
        {
            visible: true, code: 'aligncenter',
            cls: 'mr-1 f-icon f-icon-align-center',
            title: 'å±ä¸­å¯¹é½',
            value: 'aligncenter'
        },
        {
            visible: true, code: 'alignright',
            cls: 'mr-1 f-icon f-icon-align-right',
            title: 'å³å¯¹é½',
            value: 'alignright'
        },
        {
            visible: true, code: 'alignjustify',
            cls: 'mr-1 f-icon f-icon-align-justify',
            title: 'ä¸¤ç«¯å¯¹é½',
            value: 'alignjustify'
        },
        {
            visible: true, code: 'table',
            cls: 'mr-1 f-icon f-icon-table',
            title: 'è¡¨æ ¼',
            value: 'table'
        }
    ]
};

/**
 * å°è®¾è®¡æ¶çæ°æ®è½¬æ¢ä¸ºè¿è¡æ¶å¯ææ¬ç¼è¾å¨å·¥å·æ æè¯å«çæ ¼å¼
 * @param designerData è®¾è®¡æ¶æ°æ®
 */
export function Convert2HtmlEditorToolbars(type: 'advanced' | 'concise', toolbars: RichTextEditorToolbars) {
    if (!toolbars || !toolbars.length) {
        return null;
    }

    const typ: string = type.toLowerCase();
    const tools: any = toolbars;

    const allCMDs = RICH_COMMANDS[typ];
    const toolbarItems = tools.map(n => {
        if (typeof n === 'object') {
            n.values = n.values.map((s: string) => {
                return allCMDs.find(c => c.code === s);
            }).filter(t => t);

            return n;
        } else {
            return allCMDs.find(c => c.code === n);
        }
    }).filter(t => t);

    const configs = toolbarItems.map(n => {
        if (n.groupName) {
            if (typ === 'concise') {
                return n.values.map(v => v.value).flat();
            }
            return n.values.map(v => v.value);
        }
        return n.value;
    }).filter(n => n.length);

    if (typ === 'concise') {
        return configs;
    } else if (typ === 'advanced') {
        return configs.map((n, i) => {
            if (Array.isArray(n)) {
                if (i === 0) {
                    n.push('|');
                }
                if (i > 0) {
                    n.unshift('|');
                }
            }
            return n;
        }).flat().join(' ');
    }
}
